import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel
} from '@mui/material';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import ButtonComponent from 'components/design-system/Button/Button';
import CheckboxComponent from 'components/design-system/Checkbox/Checkbox';
import { OpenInNew } from '@mui/icons-material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LogoutIcon from '@mui/icons-material/Logout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { RUTAS } from 'const/Rutas';

const LegalAcceptanceModal = ({
  open,
  onClose,
  onAccept,
  onLogout,
  isProcessing = false,
  values = {},
  onChange,
  puedeContinuar = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        onClose && onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="border-b border-neutral-90 flex items-center gap-2 p-3">
        <WarningAmberIcon className="text-yellow-600 w-6 h-6" />
        <Heading type="h3" className="mb-0 text-yellow-700 font-bold">
          ¡Información importante sobre nuestra plataforma!
        </Heading>
      </DialogTitle>

      <DialogContent className="p-5 space-y-4">
        <DialogContentText className="pt-2">
          <Text>
            Hemos agregado nuestros <b>Términos y Condiciones</b>, la{' '}
            <b>Política de Privacidad</b> y el{' '}
            <b>Consentimiento Expreso e Informado</b> en la plataforma.
            <br />
            <br />
            Para continuar utilizando nuestros servicios,{' '}
            <b>es indispensable que leas y aceptes</b>. Para esto, debes{' '}
            <b>seleccionar ambas casillas</b> y luego hacer clic en el botón de{' '}
            <b>Confirmar aceptación</b> para guardar la información. En caso de{' '}
            <b>no aceptarlos, no podrás</b> continuar usando la plataforma.
          </Text>
        </DialogContentText>

        <div className="space-y-3">
          <FormControlLabel
            control={
              <CheckboxComponent
                disabled={isProcessing}
                name="terminosYCondiciones"
                value={values.terminosYCondiciones}
                onChange={onChange}
                checked={!!values.terminosYCondiciones}
              />
            }
            label={
              <Text className="text-black text-xs leading-tight">
                Declaro haber leído y aceptar los{' '}
                <a
                  href={`${window.location.origin}${RUTAS.TERMINOS_Y_CONDICIONES}`}
                  target="_blank"
                  rel="noreferrer"
                  className="font-bold text-uv-secondary-0 hover:underline inline-flex items-center"
                >
                  <span>Términos y Condiciones</span>
                  <OpenInNew className="w-3 h-3 ml-1 text-uv-secondary-0" />
                </a>{' '}
                y la{' '}
                <a
                  href={`${window.location.origin}${RUTAS.POLITICAS_PRIVACIDAD}`}
                  target="_blank"
                  rel="noreferrer"
                  className="font-bold text-uv-secondary-0 hover:underline inline-flex items-center"
                >
                  <span>Política de Privacidad</span>
                  <OpenInNew className="w-3 h-3 ml-1 text-uv-secondary-0" />
                </a>
                .
              </Text>
            }
          />

          <FormControlLabel
            control={
              <CheckboxComponent
                disabled={isProcessing}
                name="consentimientoDatos"
                value={values.consentimientoDatos}
                onChange={onChange}
                checked={!!values.consentimientoDatos}
              />
            }
            label={
              <Text className="text-black text-xs leading-tight">
                Otorgo mi{' '}
                <a
                  href={`${window.location.origin}${RUTAS.CONSENTIMIENTO_DATOS}`}
                  target="_blank"
                  rel="noreferrer"
                  className="font-bold text-uv-secondary-0 hover:underline inline-flex items-center"
                >
                  <span>Consentimiento Expreso e Informado</span>
                  <OpenInNew className="w-3 h-3 ml-1 text-uv-secondary-0" />
                </a>{' '}
                para el tratamiento de mis datos personales conforme a las
                finalidades descritas.
              </Text>
            }
          />
        </div>

        <Text>
          Si tienes <b>alguna duda</b>, puedes{' '}
          <a
            href="#"
            rel="noreferrer"
            target="_blank"
            className="font-bold text-uv-secondary-0 hover:underline"
          >
            contactarnos aquí.
          </a>
        </Text>
      </DialogContent>

      <DialogActions className="border-t border-neutral-90 p-4 justify-center">
        <ButtonComponent
          type="primary"
          autoFocus
          className="w-full xs:w-auto justify-center"
          onClick={onLogout}
          disabled={isProcessing}
          startIcon={<LogoutIcon />}
        >
          Cerrar sesión sin aceptar
        </ButtonComponent>

        <ButtonComponent
          type="primary"
          autoFocus
          className="w-full xs:w-auto justify-center"
          onClick={onAccept}
          disabled={!puedeContinuar || isProcessing}
          startIcon={<CheckCircleIcon />}
        >
          {isProcessing ? 'Procesando...' : 'Aceptar y continuar'}
        </ButtonComponent>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(LegalAcceptanceModal);
